import React from 'react';
import { Box, Grid, Paper } from '@mui/material';

interface TimeSlotsProps {
  availableSlots: string[];
  selectedTime: string | null;
  onTimeSelect: (time: string) => void;
}

const TimeSlots: React.FC<TimeSlotsProps> = ({ availableSlots, selectedTime, onTimeSelect }) => {
  return (
    <Grid container spacing={2}>
      {availableSlots.map((time) => (
        <Grid item xs={6} sm={4} md={3} key={time}>
          <Box
            onClick={() => onTimeSelect(time)}
            sx={{
              p: 2,
              textAlign: 'center',
              borderRadius: 2,
              border: 1,
              borderColor: selectedTime === time ? 'primary.main' : 'divider',
              bgcolor: selectedTime === time ? 'primary.main' : 'background.paper',
              color: selectedTime === time ? 'primary.contrastText' : 'text.primary',
              cursor: 'pointer',
              fontWeight: selectedTime === time ? 600 : 400,
              transition: 'all 0.2s',
              '&:hover': {
                bgcolor: selectedTime === time ? 'primary.dark' : 'action.hover',
              },
            }}
          >
            {time}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default TimeSlots; 